const initSystem = async ({dispatch}) => {
  dispatch('getAbilityGroups')
  dispatch('getNumbers')
  dispatch('getRoles')
}

export default {
  initSystem
}
